import BaseComponent from './BaseComponent';
import { throttle }  from 'lodash';

class AccordionRadio extends BaseComponent {
  constructor(componentName){
    super(componentName);
  }


  init(component) {
    this.addCustomEvents(component);
  }


  addCustomEvents(component) {
    const input         = component.element.getElementsByTagName('input')[0];
    const contactClick  = component.element.getElementsByClassName('contact')[0];

    let capture = { capture : true };
    let once = { once : true };

    if(!!input) {
      component.element.addEventListener('click', once, (e) => {
        e.preventDefault();
        e.stopPropagation();

        this.uncheckInputs(component.element);

        if(!input.checked) {
          requestAnimationFrame(() => {
            const contents = this.getAccordionContent(component.element);
            this.toggleAccordionContent(contents, false);
          });
          component.element.classList.add('opened');
          input.checked = true;
          // input.setAttribute('checked', 'checked');
          app.components.form.submitData(input, true);
        }
      });
    }

    if(!!contactClick) {
        contactClick.addEventListener('click', capture,  (e) => {
          input.capture = false;
          contactClick.capture = true;
        })
      }


    window.addEventListener('resize', _.throttle((e) => {
      if(component.element.classList.contains('opened')) {
        const contents = this.getAccordionContent(component.element);
        this.watchResize(contents);
      }
    }, 500));
  }


  uncheckInputs(element) {
    const inputRadio = element.getElementsByTagName('input')[0];
    const name       = inputRadio.getAttribute('name');
    const id         = element.getAttribute('id');
    const inputs     = document.querySelectorAll(`input[name='${name}']`);

    for(let input of inputs) {
      const label = input.parentElement;
      if(label.getAttribute('id') != id) {

        input.checked = false;
        input.removeAttribute('checked');

        const contents = this.getAccordionContent(label);
        this.toggleAccordionContent(contents, true);
        label.classList.remove('opened');
      }
    }
  }


  getAccordionContent(element) {
    const contentId       = element.getAttribute('data-accordion-id');
    const contentWrappers = document.getElementsByClassName('accordion__content-wrapper');
    let contentsTarget = [];

    for(let content of contentWrappers) {
      const dataId = content.getAttribute('data-id');

      if(dataId === contentId) {
        contentsTarget.push(content);
      }
    }

    return contentsTarget;
  }



  toggleAccordionContent(targets, collapse) {
    if(targets.length > 0) {
      for (let target of targets) {
        if (!!target) {
          collapse ? target.classList.remove('visible') : target.classList.add('visible');

          if (target.classList.contains('visible')) {
            target.style.height = target.scrollHeight + 'px';
          } else {
            target.style.height = 0;
          }
        }
      }
    }
  }


  watchResize(targets) {
    if(targets.length > 0) {
      for (let target of targets) {
        if (!!target) {
          if (target.classList.contains('visible')) {
            const content = target.getElementsByClassName('accordion__content')[0];
            target.style.height = !!content ? content.scrollHeight + 'px' : target.scrollHeight + 'px';
          } else {
            target.style.height = 0;
          }
        }
      }
    }
  }
}

export default AccordionRadio;
